import { defineComponent, openBlock, createElementBlock, createElementVNode, createVNode, unref, withCtx, createTextVNode, toDisplayString, createBlock, resolveDynamicComponent } from "vue";
import { CdrImg, CdrLink } from "@rei/cedar";
const _hoisted_1 = {
  class: "klarna-cobrand"
};
const _hoisted_2 = {
  class: "klarna-cobrand__cobrand"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "KlarnaCobrand",
  props: {
    klarnaPrice: {},
    cobrandMessage: {}
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const handlePreApprovalCobrandLearnMore = (event) => {
      emit("metricsClick", {
        event,
        link: props.cobrandMessage.link,
        linkName: "rei co-op mastercard_See if you’re pre-approved"
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createVNode(unref(CdrImg), {
        class: "klarna-cobrand__cobrand-img",
        src: "https://satchel.rei.com/media/product/cobrand.png",
        srcset: "https://satchel.rei.com/media/product/cobrand-2x.png 2x",
        alt: ""
      }), createElementVNode("p", null, [createElementVNode("span", {
        innerHTML: _ctx.cobrandMessage.initialText
      }, null, 8, _hoisted_3), createVNode(unref(CdrLink), {
        "data-ui": "cobrand-mastercard-link",
        href: _ctx.cobrandMessage.link,
        onClick: _cache[0] || (_cache[0] = ($event) => handlePreApprovalCobrandLearnMore($event))
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.cobrandMessage.ctaText), 1)]),
        _: 1
      }, 8, ["href"]), createElementVNode("span", {
        innerHTML: _ctx.cobrandMessage.finalText
      }, null, 8, _hoisted_4)])]), (openBlock(), createBlock(resolveDynamicComponent(`klarna-placement`), {
        id: "klarna-placement",
        "data-key": "credit-promotion-badge",
        "data-locale": "en-US",
        "data-purchase-amount": _ctx.klarnaPrice,
        "data-test": "purchase-form-klarna"
      }, null, 8, ["data-purchase-amount"]))]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=KlarnaCobrand2.mjs.map
